package com.eladfinish.bible.contest

import dev.icerock.moko.graphics.Color
import dev.icerock.moko.resources.ColorResource
import kotlin.collections.List

internal object CommonMainColors1 {
  internal val white: ColorResource by lazy { init_white() }

  internal val yellow1: ColorResource by lazy { init_yellow1() }

  internal val yellow2: ColorResource by lazy { init_yellow2() }

  internal fun values(): List<ColorResource> = listOf(white, yellow1, yellow2)
}

private fun init_white(): ColorResource = ColorResource(lightColor = Color(0xffffffff), darkColor =
    Color(0xffffffff))

private fun init_yellow1(): ColorResource = ColorResource(lightColor = Color(0xeeff41ff), darkColor
    = Color(0xeeff41ff))

private fun init_yellow2(): ColorResource = ColorResource(lightColor = Color(0xeeff41ff), darkColor
    = Color(0xeeff41ff))

public actual val SharedRes.colors.white: ColorResource
  get() = CommonMainColors1.white

public actual val SharedRes.colors.yellow1: ColorResource
  get() = CommonMainColors1.yellow1

public actual val SharedRes.colors.yellow2: ColorResource
  get() = CommonMainColors1.yellow2
